import apollo from 'graphql/apollo';
import { createShoppingCartMutation } from 'graphql/mutations';

const createShoppingCart = async ({ shoppingCart }) =>
  apollo.mutate({
    mutation: createShoppingCartMutation,
    variables: { shoppingCart },
  });
export default createShoppingCart;
